/* @flow */

import React from 'react';
import Immutable from 'immutable';
import uuid from 'uuid';
import { Card } from 'semantic-ui-react';
import GalleryImageSelector from './GalleryImageSelector';
import GalleryImage from './GalleryImage';
import { enforceElementsOrder } from 'utils/ordering';

type Props = {
  block: EditorialGalleryBlock,
  onSerialize?: (block: EditorialGalleryBlock) => void,
};

const updateImages = images => updateFunction =>
  updateFunction(Immutable.Map(images.map(i => [i.order, i])).toList());

const mergeImages = (images, updated) =>
  updateImages(images)(map =>
    map.update(updated.order, i => ({
      ...i,
      ...updated,
    }))
  );

const removeImage = (images, toDelete) =>
  updateImages(images)(map => map.remove(toDelete.order));

const Edit = ({ block, onSerialize }: Props) => {
  const updateImages = images =>
    onSerialize({
      ...block,
      images,
    });

  const imageSelected = (resource: BucketResource) => {
    const images = block.images || [];
    const newImage = {
      id: uuid(),
      order: images.length,
      blockId: block.id,
      resource,
    };

    updateImages([...images, newImage]);
  };

  const imageUpdated = (updated: EditorialGalleryImage) => {
    const newImages = mergeImages(block.images, updated);
    updateImages(newImages.toArray());
  };

  const imageDeleted = (image: EditorialGalleryImage) => {
    const newImages = enforceElementsOrder(removeImage(block.images, image));
    updateImages(newImages.toArray());
  };

  if (block.images && block.images.length) {
    return (
      <div>
        <GalleryImageSelector onSelected={imageSelected} />
        <Card.Group itemsPerRow={4}>
          {block.images.map(i => (
            <GalleryImage
              key={i.order}
              image={i}
              onUpdate={imageUpdated}
              onDelete={imageDeleted}
            />
          ))}
        </Card.Group>
      </div>
    );
  }

  return <GalleryImageSelector onSelected={imageSelected} />;
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/gallery/Edit.js